import type { Media, Theme } from '../../types/props'

export interface ThreeDCarouselItem {
  /** 主题 */
  theme?: Theme
  /** 桌面端图片 */
  imageUrl: Media | null
  /** 移动端图片 */
  mobImageUrl: Media | null
  /** 标题 */
  title: string
  /** 描述 */
  description: string
  /** 按钮文本 */
  buttonText?: string
  /** 按钮链接 */
  buttonLink?: string | null
}

export interface ThreeDCarouselProps {
  data: {
    title: string
    /** 轮播项列表 */
    items: ThreeDCarouselItem[]
  }
  /** 自定义类名 */
  className?: string
}
